<script setup lang="ts">
import { computed } from 'vue'
import { ImageReviewStates } from 'Modules/types/generic/image/ImageReviewStates'
import type { ImageType } from 'Modules/types/pages/imageReview/imageType'
import type { WaypointType } from 'Modules/types/pages/imageReview/waypoint'

interface PropTypes {
  image: ImageType
  waypoint: WaypointType
}
const props = defineProps<PropTypes>()

const addsComplete = computed<boolean>(() => props.image?.isAddsReviewed)
const reviewComplete = computed<boolean>(() => props.image?.reviewState === ImageReviewStates.Complete)
</script>

<template>
  <div class="w-full grid text-sm grid-cols-2 grid-rows-6 px-4 pt-4">
    <span class="font-semibold text-base col-span-2 place-self-start">Waypoint</span>
    <span class="place-self-start">Name</span>
    <span class="place-self-end">{{ props.waypoint?.name }}</span>
    <span class="place-self-start">Order</span>
    <span class="place-self-end">{{ props.waypoint?.wporder }}</span>
    <span class="font-semibold text-base col-span-2 place-self-start">Status</span>
    <span class="place-self-start">ADDS</span>
    <span class="place-self-end">{{ addsComplete ? 'Complete' : 'Incomplete' }}</span>
    <span class="place-self-start">Review</span>
    <span class="place-self-end">{{ reviewComplete ? 'Complete' : 'Incomplete' }}</span>
  </div>
</template>
